import * as C from '../Constants'
export function fetchGlobalData(){
    return function(dispatch){
        dispatch(fetching_GlobalData());
        fetch('https://api.covid19api.com/summary')
        .then(res => res.json())
        .then(globaldata=> {
          dispatch(fetch_GlobalData_Success(globaldata));
        return globaldata;
        })
       
    }
}





export const fetching_GlobalData = () => ({
            type:C.GET_GLOBALDATA
})

export const fetch_GlobalData_Success = (GlobalData) => ({
        type:C.GET_GLOBALDATA_SUCCESS,
        Global_Stat:GlobalData.Countries
});